<template>
  <QuestionWrapper>
    <QuestionTitle>
      Imagine the future, what's most important?
    </QuestionTitle>
    <ChoicesWrapper>
      <Choice
        v-bind:selected="question.selected"
        @click="setGoal(question.id)"
        v-for="question in questions"
        >
        <ChoiceTitle>{{question.title}}</ChoiceTitle>
        <ChoiceBlurb>{{question.blurb}}</ChoiceBlurb>
        <ChoiceContext>{{question.context}}</ChoiceContext>
      </Choice>
    </ChoicesWrapper>
  </QuestionWrapper>
</template>

<script>
export default {
  data: function() {
    return {
      questions: [{
          title: "Repetiore",
          blurb: "Play your favorites",
          context: "Have great list of songs at your disposal.",
          selected: false,
          id: "important-new-songs"
        },
        {
          title: "Jam",
          blurb: "Improvisation",
          context: "Play from you heart, mind, alone or with a group.",
          selected: false,
          text: '',
          id: 'important-music-concepts'
        },
        {
          title: "Expansion",
          blurb: "Growth and virtuosity",
          context: "Enjoy the struggles and rewards of constant imporovement",
          selected: false,
          id: 'important-guidence'
        }
      ]
    }
  },
  methods: {
    setGoal(questionID) {
      this.questions.forEach( (question, index) => {
        console.log(question)
        if (question.id === questionID){
            question.selected = true
        } else {
            question.selected = false
        }
      })

      this.$store.commit('setGoal', questionID)
    }
  }
}
</script>
<style scoped>
.main {
  display: grid;
  grid-template-rows: 3fr 7fr 1fr;
  background: #6699ff;
  /* padding-left: 15px;
    padding-right: 15px;
    width: 85%;
    padding-left: 7.5%;
    padding-right: 7.5%;
    box-shadow: 10px;
    min-height: 5px; */
}

.title {
  display: grid;
  text-align: center;
  text-justify: center;
  color: white;
  width: 100%;
  align-self: center;
  height: 15px;
}

.next {
  display: grid;
  color: white;
  align-self: flex-end;
  text-align: center;
  margin-right: 5%;
  margin-left: 80%;
  margin-bottom: 10px;
  width: 60px;
  background: rgb(11, 42, 64);
  font-size: 15px;
}

.questions {
  text-align: left;
  color: white;
  grid-template-rows: 1fr 1fr 1fr 1fr;
  font-size: 16px;
  text-align: center;
  text-justify: center;
  list-style-type: none;
}
</style>



// WEBPACK FOOTER //
// src/components/onboarding/Question3.vue